import React, { MouseEventHandler, PropsWithChildren } from "react";
import { Link } from "react-router-dom";
import cx from "classnames";
import "./styles.scss";

interface Props {
  to?: string;
  toClick?: () => void;
  onClick?:
    | MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>
    | undefined;
  className?: string;
  isText?: boolean;
  colorEnabled?: boolean;
  disabled?: boolean;
  "data-testid"?: string;
}

const ProfileButton = ({
  to,
  onClick,
  toClick,
  className,
  isText,
  children,
  colorEnabled = true,
  disabled,
  "data-testid": dataTestId,
}: PropsWithChildren<Props>) => {
  const classes = cx(
    "profile-button",
    {
      "profile-button--text": isText,
      "profile-button--colored": colorEnabled,
    },
    className
  );

  if (to) {
    return (
      <Link
        className={classes}
        to={to}
        onClick={toClick}
        data-testid={dataTestId}
      >
        {children}
      </Link>
    );
  }

  return (
    <button
      onClick={onClick}
      className={classes}
      disabled={disabled}
      data-testid={dataTestId}
    >
      {children}
    </button>
  );
};

export default ProfileButton;
